// Dropdown for .custom-dropdown-icon inside tables
// Bound only to this class — won't affect Bootstrap dropdowns elsewhere

document.addEventListener('click', (e) => {
  const toggle = e.target.closest('.custom-dropdown-icon .dropdown-toggle');

  // Close all open menus on any outside click
  if (!toggle) {
    document.querySelectorAll('.custom-dropdown-icon .dropdown-menu.show').forEach((menu) => {
      menu.classList.remove('show');
      menu.closest('.custom-dropdown-icon').querySelector('.dropdown-toggle')?.setAttribute('aria-expanded', 'false');
    });
    return;
  }

  e.preventDefault();

  const icon = toggle.closest('.custom-dropdown-icon');
  const menu = icon.querySelector('.dropdown-menu');
  const isOpen = menu.classList.contains('show');

  // Close all others first
  document.querySelectorAll('.custom-dropdown-icon .dropdown-menu.show').forEach((m) => {
    if (m !== menu) {
      m.classList.remove('show');
      m.closest('.custom-dropdown-icon').querySelector('.dropdown-toggle')?.setAttribute('aria-expanded', 'false');
    }
  });

  // Toggle current
  menu.classList.toggle('show', !isOpen);
  toggle.setAttribute('aria-expanded', String(!isOpen));
});
